function place(state = {}) {
  return state;
}

export default place;



// WEBPACK FOOTER //
// ./assets/shared/reducers/place.js